// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import * as moment from 'moment';
import { StampManagerType } from '../SagaBase';
import { CStampCard_abstract } from './../abstract/SagaSchema/CStampCard_abstract';

export class CStampCard extends CStampCard_abstract {
  jsonData: any = null;

  get icon(): string {
    switch (this.StampType) {
      case StampManagerType.Status:
        return 'flag';
      case StampManagerType.Merge:
        return 'git-merge';
      case StampManagerType.Export:
        return 'open';
      case StampManagerType.Escalade:
        return 'arrow-round-up';
      case StampManagerType.Link:
        return 'briefcase';
      case StampManagerType.CreateTacticalSituation:
      case StampManagerType.SaveTacticalSituation:
      case StampManagerType.RemoveTacticalSituation:
        return 'map';
      case StampManagerType.EffectiveDate:
        return 'calendar';
    }
    return 'document';
  }

  get text() {
    if (this.StampType === StampManagerType.EffectiveDate) {
      return moment(this.EffectiveDateUtc).format('LLL');
    }
    return this.Text;
  }
}
